import React, { useEffect, useState } from "react";
import axios from "axios";
import Papa from "papaparse";
import { Table } from "react-bootstrap";
import "styles/page.css";
import "./UnitTrustPrice.css";
import { convertDateFormat } from "utils";

const UnitTrustPrice = () => {
  const [unitTrustPrice, setUnitTrustPrice] = useState({});

  const fetchUnitTrustPrice = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/unit-trust-prices?populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );
      setUnitTrustPrice(response.data.data[0]);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (_.isEmpty(unitTrustPrice)) {
      fetchUnitTrustPrice();
    }
  }, []);

  return (
    <>
      <div className="container page">
        <h1 className="page-title">Unit Trust Price</h1>

        <Table responsive="xs" bordered>
          <thead>
            <tr className="table-title">
              <th>Unit Trust Price</th>
              <th colSpan="2">
                As of{" "}
                {!_.isEmpty(unitTrustPrice) &&
                  convertDateFormat(unitTrustPrice?.date)}
              </th>
            </tr>
            <tr className="table-head">
              <th>Fund</th>
              <th>NAV</th>
            </tr>
          </thead>
          <tbody>
            {!_.isEmpty(unitTrustPrice) &&
              unitTrustPrice?.unitTrusts?.map((item, index) => {
                const formattedNav =
                  !isNaN(item.nav) && !isNaN(parseFloat(item.nav))
                    ? parseFloat(item.nav).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 5,
                      })
                    : item.nav;
                return (
                  <tr className="table-data" key={index}>
                    <td>{item.fund}</td>
                    <td>{formattedNav}</td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default UnitTrustPrice;
